@if (crumbConfig) {
  <div class="breadcrumb" id="breadcrumb">
    @if (toolsLanding) {
      <button mat-button (click)="nav('tools')">
        <mat-icon>home</mat-icon>
        <span class="text-container">Home</span>
      </button>
    } @else {
      <button mat-button (click)="nav('')">
        <mat-icon>home</mat-icon>
        <span class="text-container">Home</span>
      </button>
    }

    @for (
      crumb of crumbConfig;
      track crumb;
      let idx = $index, first = $first, last = $last
    ) {
      /
      <button mat-button (click)="nav(crumb.link)" [disabled]="last">
        <span class="text-container">{{ crumb.label }}</span>
      </button>
    }
  </div>
} @else {
  <div class="breadcrumb" id="breadcrumb">
    @for (
      crumb of crumbs;
      track crumb;
      let idx = $index, first = $first, last = $last
    ) {
      @if ((hideCrumbs && idx > 1) || !hideCrumbs) {
        @if (first) {
          <mat-icon>home</mat-icon>
        }
        @if (!first) {
          <mat-icon>arrow_forward</mat-icon>
        }
        <button mat-button (click)="nav(crumb.link)" [disabled]="last">
          @if (!last || first) {
            <span class="text-container">{{ crumb.label }}</span>
          }
          @if (last && !first) {
            <strong>{{ crumb.label }}</strong>
          }
        </button>
      }
    }
  </div>
}
